export default __webpack_public_path__ + "static/media/d_todo.57f66863.webp";